import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * SectionHeader — the homepage section header pattern:
 * eyebrow pill (icon + label) · bold title with brand scanline · "view all" pill.
 * `accent` is a hex colour that keeps each market section's own identity.
 */
export const SectionHeader = ({ icon: Icon, accent = '#1E9BD9', eyebrow, title, link, isDarkMode, isAr, testId }) => (
  <div className="flex items-end justify-between gap-4 mb-5 sm:mb-7" data-testid={testId}>
    <div className="min-w-0">
      <div
        className="inline-flex items-center gap-2 border px-3 py-1 rounded-full mb-2.5"
        style={{ background: `${accent}14`, borderColor: `${accent}40`, color: accent }}
      >
        {Icon && <Icon className="h-3.5 w-3.5" />}
        <span className="text-xs font-semibold">{eyebrow}</span>
      </div>
      <h2 className={`text-2xl sm:text-3xl font-bold tracking-tight leading-tight ${isDarkMode ? 'text-white' : 'text-[#0F172A]'}`}>
        {title}
      </h2>
      <div className="mt-2 h-[2px] w-24 rounded-full" style={{ background: `linear-gradient(90deg, ${accent}, #F5A962)` }} />
    </div>
    {link && (
      <Link
        to={link}
        className={`shrink-0 inline-flex items-center gap-2 px-4 h-10 rounded-xl text-sm font-semibold border transition-all hover:-translate-y-0.5 ${isDarkMode ? 'bg-white/[0.03] border-white/10 text-slate-200 hover:border-[#1E9BD9]/50' : 'bg-white border-slate-200 text-slate-700 hover:border-[#1E9BD9]/50 shadow-sm'}`}
        data-testid={testId ? `${testId}-view-all` : undefined}
      >
        {isAr ? 'عرض الكل' : 'View All'}
        <ArrowRight className={`h-4 w-4 ${isAr ? 'rotate-180' : ''}`} style={{ color: accent }} />
      </Link>
    )}
  </div>
);

export default SectionHeader;
